import React from 'react';

const WeekView = ({ 
  currentDate, 
  events, 
  onEventClick, 
  language 
}) => {
  const getWeekDays = (date) => {
    const week = [];
    const current = new Date(date);
    const day = current?.getDay();
    const diff = current?.getDate() - day;

    for (let i = 0; i < 7; i++) {
      const weekDay = new Date(current);
      weekDay?.setDate(diff + i);
      week?.push(weekDay);
    }

    return week;
  };

  const weekDays = getWeekDays(currentDate);
  const hours = Array.from({ length: 24 }, (_, i) => i);

  const dayNames = {
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    fr: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    ar: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
  };

  const days = dayNames?.[language] || dayNames?.en;

  const getEventsForDateTime = (date, hour) => {
    const dateStr = date?.toISOString()?.split('T')?.[0];
    return events?.filter(event => {
      if (event?.date !== dateStr) return false;
      const eventHour = parseInt(event?.time?.split(':')?.[0]);
      return eventHour === hour;
    });
  };

  const isToday = (date) => {
    const today = new Date();
    return (date?.getDate() === today?.getDate() &&
    date?.getMonth() === today?.getMonth() && date?.getFullYear() === today?.getFullYear());
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <div className="min-w-[800px]">
          <div className="grid grid-cols-8 border-b border-border sticky top-0 bg-card z-10">
            <div className="p-3 border-r border-border bg-muted/50" />
            {weekDays?.map((date, index) => (
              <div
                key={index}
                className={`p-3 text-center border-r border-border ${
                  isToday(date) ? 'bg-primary/5' : 'bg-muted/50'
                }`}
              >
                <div className={`text-sm font-semibold ${
                  isToday(date) ? 'text-primary' : 'text-muted-foreground'
                }`}>
                  {days?.[index]}
                </div>
                <div className={`text-lg font-bold mt-1 ${
                  isToday(date) ? 'text-primary' : 'text-foreground'
                }`}>
                  {date?.getDate()}
                </div>
              </div>
            ))}
          </div>

          <div className="max-h-[600px] overflow-y-auto">
            {hours?.map((hour) => (
              <div key={hour} className="grid grid-cols-8 border-b border-border min-h-[60px]">
                <div className="p-2 border-r border-border bg-muted/30 text-xs text-muted-foreground text-center">
                  {String(hour)?.padStart(2, '0')}:00
                </div>
                {weekDays?.map((date, dayIndex) => {
                  const dayEvents = getEventsForDateTime(date, hour);
                  return (
                    <div
                      key={dayIndex}
                      className={`p-1 border-r border-border hover:bg-muted/50 transition-colors ${
                        isToday(date) ? 'bg-primary/5' : ''
                      }`}
                    >
                      {dayEvents?.map((event) => (
                        <div
                          key={event?.id}
                          onClick={() => onEventClick(event)}
                          className={`text-xs px-2 py-1 rounded mb-1 cursor-pointer hover:opacity-80 transition-opacity ${
                            event?.type === 'hearing' ? 'bg-error text-error-foreground' :
                            event?.type === 'appointment' ? 'bg-primary text-primary-foreground' :
                            event?.type === 'deadline' ? 'bg-warning text-warning-foreground' :
                            'bg-success text-success-foreground'
                          }`}
                        >
                          <div className="font-medium truncate">{event?.title}</div>
                          <div className="opacity-90">{event?.time}</div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeekView;